/**
 * Plans v2 card 2.4: the state of the plan-claim expiry check, alone in a
 * file with no other import so the MCP bus can read it without pulling the
 * check (API client, auth service) into the MCP import graph.
 *
 *   'ok' | 'checking' | 'expired'   (see plans/claimExpiry.js)
 */
import { create } from 'zustand';

export const useClaimExpiryStore = create(() => ({ state: 'ok' }));

/** True while the app requires sign-in because the claim ran out offline. */
export const signInRequired = () => useClaimExpiryStore.getState().state === 'expired';

export const SIGN_IN_REQUIRED_MESSAGE =
  'Sign in to Apiboo: the app has been offline for more than 14 days, so the account must be confirmed again before anything is served.';
